import classNames from "classnames";
import { KeyboardEvent as ReactKeyboardEvent, useEffect, useRef, useState } from "react";
import { Icon } from "react-frontier";
import { UserClass } from "../SiteClasses";
import API from "../API";

interface Props{
   taggedUsers: UserClass[];
   setTaggedUsers: (users: UserClass) => void;
   removeTaggedUser?: (user: UserClass) => void;
}

var UserMentions=({ taggedUsers, setTaggedUsers, removeTaggedUser }: Props)=>{
   var [inputEmpty, setInputEmpty] = useState<boolean>(true);
   var [mentionSearch, setMentionSearch] = useState<string>("");
   var [mentionUsers, setMentionUsers] = useState<UserClass[]>([]);
   var [showMentions, setShowMentions] = useState<boolean>(false);
   var [selectedMentionIndex, setSelectedMentionIndex] = useState<number>(0);

   var inputRef = useRef<HTMLDivElement>(null);

   useEffect(()=>{
      if(showMentions){
         searchMentionUsers();
      }else{
         setMentionUsers([]);
         setSelectedMentionIndex(0);
      }
   }, [showMentions, mentionSearch]);

   var searchMentionUsers=()=>{
      API.searchUsers(mentionSearch, 0, 10).then(res=>{
         if(!res.error) setMentionUsers(res.data);
      }).catch(()=>{});
   }

   var onInput = (ev: React.FormEvent<HTMLDivElement>)=>{
      var text = ev.currentTarget.textContent || '';
      setInputEmpty(text.length === 0);
            
      var lastAtIndex = text.lastIndexOf('@');
            
      if(lastAtIndex !== -1){
         var textAfterAt = text.substring(lastAtIndex + 1);
         if(!textAfterAt.includes(' ')){
            setShowMentions(true);
            setMentionSearch(textAfterAt);
            setSelectedMentionIndex(0);
            return;
         }
      }
         
      setShowMentions(false);
      setMentionSearch("");
   };

   var insertMention = (user: UserClass)=>{
      setTaggedUsers(user);
      if(inputRef.current){
         inputRef.current.textContent = '';
      }
      
      setShowMentions(false);
      setMentionSearch("");
      setInputEmpty(true);
   };

   var onMentionKeyDown = (ev: ReactKeyboardEvent<HTMLDivElement>)=>{
      switch(ev.key){
         case 'ArrowDown':
            ev.preventDefault();
            setSelectedMentionIndex(prev=>Math.min(prev + 1, mentionUsers.length - 1));
            break;
         case 'ArrowUp':
            ev.preventDefault();
            setSelectedMentionIndex(prev=>Math.max(prev - 1, 0));
            break;
         case 'Enter':
         case 'Tab':
            ev.preventDefault();
            if(mentionUsers[selectedMentionIndex]){
               insertMention(mentionUsers[selectedMentionIndex]);
            }
            break;
         case 'Escape':
            setShowMentions(false);
            setMentionSearch("");
            break;
      }
   };

   var onInputKeyDown = (ev: ReactKeyboardEvent<HTMLDivElement>)=>{
      if(showMentions){
         onMentionKeyDown(ev);
      }else if(ev.key === 'Enter'){
         if(ev.ctrlKey){
            ev.preventDefault();
            var selection = window.getSelection();
            if(selection && selection.rangeCount > 0){
               var range = selection.getRangeAt(0);
               range.deleteContents();
                  
               var br = document.createElement('br');
               range.insertNode(br);
                  
               var textNode = document.createTextNode('');
               br.parentNode?.insertBefore(textNode, br.nextSibling);
                  
               range.setStart(textNode, 0);
               range.collapse(true);
               selection.removeAllRanges();
               selection.addRange(range);
                  
               if(inputRef.current){
                  var event = new Event('input', { bubbles: true });
                  inputRef.current.dispatchEvent(event);
               }
            }
         }else{
            ev.preventDefault();
            // sendComment();
         }
      }
   };

   return <div className="ar comments-container" style={{ display: 'block', height: 'auto' }}>
      <style>{`
         .input.tagger-input.empty:before {
            content: 'Etiqueta usuarios con @' !important;
         }
      `}</style>
      <div className="textbox">
         <div 
            className={classNames('input tagger-input', { empty: inputEmpty && taggedUsers && taggedUsers.length === 0 })} 
            style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: 'center', minHeight: 40, cursor: 'text' }}
            onClick={() => inputRef.current?.focus()}
         >
            {taggedUsers && taggedUsers.map(user => (
               <div key={user.user_id} className="input-mention" style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                  @{user.first_name} {user.last_name}
                  <span 
                     style={{ cursor: 'pointer', marginLeft: 5, display: 'inline-flex', alignItems: 'center' }} 
                     onClick={(e: React.MouseEvent) => {
                        e.stopPropagation();
                        removeTaggedUser(user);
                     }} 
                  >
                     <Icon name="close" style={{ fontSize: 14, margin: 0 }} />
                  </span>
               </div>
            ))}
            <div 
               ref={inputRef} 
               onInput={onInput} 
               contentEditable 
               onKeyDown={onInputKeyDown} 
               style={{ flex: 1, minWidth: 100, outline: 'none' }}
            />
         </div>
         {showMentions && mentionUsers.length > 0 && (
            <div className="mentions-dropdown" onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}>
               {mentionUsers.map((mentionUser, index)=>(
                  <div 
                     key={mentionUser.user_id}
                     className={classNames('mention-item', { selected: index === selectedMentionIndex })}
                     onMouseDown={(e)=>{ e.preventDefault(); e.stopPropagation(); }}
                     onClick={()=>insertMention(mentionUser)}
                     onMouseEnter={()=>setSelectedMentionIndex(index)}
                  >
                     <Icon name='user' />
                     <span className="name">{mentionUser.name || `${mentionUser.first_name || ''} ${mentionUser.last_name || ''}`.trim()}</span>
                     <span className="email">{mentionUser.email}</span>
                  </div>
               ))}
            </div>
         )}
      </div>
   </div>
}

export default UserMentions;